module.exports = __webpack_public_path__ + "static/media/2OMB-2SHARES.a18c2ef1.png";